var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHakiBracelet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 40c0 2.3-1.9 4.6-5.5 6.8-3.6 2-8.8 3.9-15.1 5.2-3.7.8-7.7.7-12 .3l-3.3-.2c-3.4-.3-7-.6-10.6-.6-3.6 0-7.2.3-10.6.6l-3.2.2c-4.4.4-8.4.5-12.1-.3A52.8 52.8 0 0 1 9 46.8c-3.6-2.2-5.5-4.5-5.5-6.8 0-1.8 1.2-3.7 3.5-5.4a34 34 0 0 1 10-4.7c8.4-2.7 20-4.4 33-4.4s24.6 1.7 33 4.4a34 34 0 0 1 10 4.7c2.3 1.7 3.5 3.6 3.5 5.4Z",
    stroke: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 50.3C74.5 47.6 62.9 46 50 46c-12.9 0-24.5 1.6-33 4.3",
    stroke: "#039BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 40v22c0 4.4-4 7-16.5 10-7.4 1.8-15 5.5-30 5.5S27.4 73.8 20 72C7.6 69 3.5 66.4 3.5 62V40",
    stroke: "#039BE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 36,
    r: 4.5,
    stroke: "#039BE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 37,
    r: 2.5,
    stroke: "#039BE5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 2.5,
    stroke: "#039BE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 36.5c0-5-2.8-7.1-7-7.5-6.3-.6-9-3-12-3h-4",
    stroke: "#039BE5",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 36c0 5-2.8 7.1-7 7.5-6.3.6-9 2.6-12 2.6l-4 .4",
    stroke: "#039BE5",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 61c3.5.5 1-2 6.5-5.5s9-2.5 12.5 2c2.8 3.6-1 5.8-3 7a2.9 2.9 0 0 0-1.5 4c.5 1 2.7.8 4 0 1-.8 3-2 5 0s2 5.3 2.5 6",
    stroke: "#039BE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52.5c1.2 6.4 4.5 8.2 6 8 2 0 6.4.8 8 4 2 4 8 8 11.5 5s6-6 2.5-10c-2.8-3.2 1.5-3.7 4-3.5 2 .3 5.8.6 5-1-.8-1.6 1.2-2.5.5-2.5",
    stroke: "#039BE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47.5c.5-2.8 2.6-8.7 5-7.5 3 1.5 1 3.5 3.5 3.5s3-1.5 4 0c.8 1.2 2 2.2 2.5 2.5",
    stroke: "#039BE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75.5c-.3-2.2 0-6.6 4-7 5-.5 4 1.5 6.5 2s5-.5 5.5.5",
    stroke: "#039BE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 50c-.5 4-3.5 6.5 0 8 2.8 1.2 5.5-1.2 6.5-2.5.3-1 1.5-3 3.5-3s2.8-2 3-3",
    stroke: "#039BE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 34c2.2-.7 7-1.2 9 2 2.5 4 6.5 5 8 2.5 1.2-2 1.8-5.2 2-6.5.5-1.7 2.2-4.3 5-1.5s4.2-1.5 4.5-4",
    stroke: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHakiBracelet);
export default ForwardRef;